import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PayWithPointsState } from '.';

export const getPayWithPoints = createFeatureSelector<PayWithPointsState>('pay-with-points');
export const getBalanceState = createSelector(getPayWithPoints, (state) => state.balance);
export const getPoints = createSelector(getBalanceState, (state) => state.points);
